// require('featherlight/src/featherlight')($);
// require('featherlight/src/featherlight.gallery')($);

import 'featherlight/src/featherlight';
import 'featherlight/src/featherlight.gallery';

let _this =  {

	/*-------------------------------------------------------------------------------
		# Cache dom and strings
	-------------------------------------------------------------------------------*/
	$dom: {
		lightbox: $('#lightbox'),
		imageGallery: $('a.ig-block-image-slider__slide')
    },

    vars: {
	},

	/*-------------------------------------------------------------------------------
		# Initialize
	-------------------------------------------------------------------------------*/
	init: function () {

		this.$dom.lightbox.featherlight({
			type: 'image'
		});

		this.$dom.imageGallery.featherlightGallery({
			previousIcon: `<div class='arrow-container arrow-container--left'>
							<svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd"><path d="M21.883 12l-7.527 6.235.644.765 9-7.521-9-7.479-.645.764 7.529 6.236h-21.884v1h21.883z"/></svg>
						</div>`,
			nextIcon : `<div class='arrow-container arrow-container--right'>
							<svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd"><path d="M21.883 12l-7.527 6.235.644.765 9-7.521-9-7.479-.645.764 7.529 6.236h-21.884v1h21.883z"/></svg>
						</div>`,
			galleryFadeIn: 100,
			openSpeed: 300
		});
	}

};

export default _this;